import { iParsedEntity, iParsedEntityWithDisplay } from '../interfaces/iEntityParsed';
import { iMasterTable } from '../interfaces/iMasterTable';

export function filterEntities(value: string, options: iParsedEntity[], masterTables: iMasterTable[]): iParsedEntityWithDisplay[] {
    const filterValue = (value || '').toLowerCase();

    const normalize = (str: string) => str.replace(/_/g, '');

    return options
        .map((option) => {
            const entityNameLower = normalize(option.entityName.toLowerCase());
            const masterTable = masterTables.find((table) => normalize(table.MasterTableNm.toLowerCase()) === entityNameLower);
            return masterTable ? { ...option, displayName: masterTable.MasterTableUiLabelTxt } : null;
        })
        .filter((option): option is iParsedEntityWithDisplay => option !== null)
        .filter((option) => option.displayName.toLowerCase().includes(filterValue))
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
